import { Outlet } from "react-router-dom";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import BackTopBtn from "../../components/backTopBtn/BackTopBtn";

const Main = () => {
  return (
    <div className="bg-primary relative ">
      <Header />
      {/* pt-24 -> padding-top: 96px // cause our navbar is fixed to the top and it's height is h-24 (96px)  */}
      <div className="min-h-screen pt-24 ">
        <Outlet />
      </div>

      <Footer />
      <BackTopBtn />
    </div>
  );
};

export default Main;
